import Api from "../Utils/Axios";

export const GetSubscriptionReports = async (params = {}) => {
  const response = await Api.get("subscription/reports", { params });
  return response.data;
};

export const GetSubscriptionUsers = async (params = {}) => {
  const response = await Api.get("subscription/users", { params });
  return response.data;
};

export const GetClientUserAutocomplete = async (params = {}) => {
  const response = await Api.get("clientUser/autocomplete", { params });
  return response.data;
};

export const GetFreePaidUserStats = async (params = {}) => {
  const response = await Api.get("subscription/free-paid-users", { params });
  return response.data;
};

export const GetCancelledUsers = async (params = {}) => {
  const response = await Api.get("subscription/cancelled-users", { params });
  return response.data;
};

export const CancelSubscription = async (data = {}) => {
  const response = await Api.post("subscription/cancel", data);
  return response.data;
};